
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Clock, Tag, ArrowLeft } from 'lucide-react';

interface StoreStationLandingProps {
  onNavigate: (page: 'timing' | 'labels') => void;
  onBack: () => void;
}

export const StoreStationLanding = ({ onNavigate, onBack }: StoreStationLandingProps) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white p-6 flex flex-col">
      <div className="flex items-center justify-between mb-8">
        <Button 
          onClick={onBack} 
          variant="outline"
          className="flex items-center gap-2"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Main
        </Button>
        <h1 className="text-3xl font-bold text-gray-900">Store Station</h1>
        <div></div>
      </div>

      <div className="flex-1 flex items-center justify-center">
        <div className="grid gap-6 md:grid-cols-2 max-w-2xl">
          {/* Timing Station */}
          <Card className="hover:shadow-lg transition-shadow cursor-pointer p-8 text-center" onClick={() => onNavigate('timing')}>
            <div className="flex justify-center mb-4">
              <Clock className="w-16 h-16 text-blue-600" />
            </div>
            <CardTitle className="text-xl text-blue-800">Employee Timing</CardTitle>
          </Card>

          {/* Labels Station */}
          <Card className="hover:shadow-lg transition-shadow cursor-pointer p-8 text-center" onClick={() => onNavigate('labels')}>
            <div className="flex justify-center mb-4">
              <Tag className="w-16 h-16 text-green-600" />
            </div>
            <CardTitle className="text-xl text-green-800">Product Labels</CardTitle>
          </Card>
        </div>
      </div>
    </div>
  );
};
